<template>
    <div class="w-full flex flex-wrap mx-auto -px-2">
        <div class="w-full hidden lg:block px-2 lg:w-1/5">
            <sidebar :links="links" />
        </div>
        <div class="w-full lg:w-4/5 px-2">
            <router-view :key="$route.name"></router-view>
        </div>
    </div>
</template>

<script>
import Sidebar from "./sidebar";

export default {
    components: {
        Sidebar,
    },

    data() {
        return {
            links: [
                {
                    title: "Продажи",
                    route: {
                        name: "admin.billing.orders.index",
                    },
                    icon: "fas fa-cubes",
                    index: null,
                    show: this.can("manage-orders"),
                },

                {
                    title: "Аренда",
                    route: {
                        name: "admin.billing.rentals.index",
                    },
                    icon: "fas fa-dolly",
                    index: null,
                    show: this.can("manage-rentals"),
                },

                {
                    title: "Счета на оплату",
                    route: {
                        name: "admin.billing.invoices.index",
                    },
                    icon: "fas fa-university",
                    index: null,
                    show: this.can("manage-orders"),
                },

                {
                    title: "Абонементы",
                    route: {
                        name: "admin.billing.subscriptions.index",
                    },
                    icon: "fas fa-university",
                    index: null,
                    show: this.can("manage-orders"),
                },
            ],
        };
    },
};
</script>